<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [emptyState]="{
    title: 'Sin bases de operaciones',
    subtitle:
      'Todavía no hay bases cargadas o ninguna coincide con los filtros.',
  }"
></app-tabla>
